import { useEffect, useState } from "react";
import styles from "../MarketPlace/MarketPlaceDetail/MarketPlaceDetail.module.css";
import { BsArrowLeftCircle } from "react-icons/bs";
import NeedAdminApproval from "./Need_Admin_Approval.js";
import OrderApproval from "./Order_Approval.js";
import { useLocation, useNavigate } from "react-router-dom";

const sortOrdersByLatestFirst = (items) =>
  [...(Array.isArray(items) ? items : [])].sort((a, b) => {
    const aTime = new Date(
      a?.createdAt || a?.created_at || a?.updatedAt || a?.updated_at || 0,
    ).getTime();
    const bTime = new Date(
      b?.createdAt || b?.created_at || b?.updatedAt || b?.updated_at || 0,
    ).getTime();
    if (aTime !== bTime) return bTime - aTime;
    return Number(b?.id || 0) - Number(a?.id || 0);
  });

function Orders() {
  const navigate = useNavigate();
  const location = useLocation();
  const [orders, setOrders] = useState([]);
  const [ordersLoading, setOrdersLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("order_Appoval");

  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);

  useEffect(() => {
    const fetchOrders = async () => {
      setOrdersLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_SERVER_URL}/get_all_orders`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
          },
        );
        if (response.status === 200) {
          const data = await response.json();
          setOrders(sortOrdersByLatestFirst(data.data));
        } else if (response.status === 401) {
          navigate("/login");
        }
      } catch (err) {
        console.log(err);
      } finally {
        setOrdersLoading(false);
      }
    };

    fetchOrders();
  }, [navigate]);

  return (
    <div>
      <div className={styles.topHeader}>
        <div className={styles.backButton}>
          <BsArrowLeftCircle
            style={{ fontSize: "24px", borderRadius: "50%" }}
          />
        </div>
        <h1 className={styles.marketPlaceHeading}>Order Approvals</h1>
      </div>
      {/* Tabbed Container */}
      <div className={styles.TabbedContainer}>
        <div className={styles.tabHeader}>
          <h1
            className={`${styles.tab} ${
              activeTab === "order_Appoval" ? styles.activeTab : ""
            }`}
            onClick={() => setActiveTab("order_Appoval")}
          >
            Order Approval
          </h1>
          <h1
            className={`${styles.tab} ${
              activeTab === "need_Admin_Approval" ? styles.activeTab : ""
            }`}
            onClick={() => setActiveTab("need_Admin_Approval")}
          >
            Need Admin Approval
          </h1>
        </div>
      </div>

      {activeTab === "order_Appoval" && (
        <div className={styles.Container}>
          <OrderApproval orders={orders} loading={ordersLoading} />
        </div>
      )}

      {activeTab === "need_Admin_Approval" && (
        <div className={styles.Container}>
          <NeedAdminApproval />
        </div>
      )}
    </div>
  );
}

export default Orders;
